import { useEffect, useState } from 'react';

/**
 * useTheme — brand-default dark, persisted to localStorage and reflected on <html>.
 *
 * The initial paint is set by the inline script in public/index.html (so the login
 * screen never flashes the wrong theme); this hook keeps React in sync afterwards
 * and exposes the toggle. Brand-primary theme is dark (gold on black).
 */
/* TEMPORARY (Design Phase 1): light mode isn't styled across all tabs yet, so the app
   is locked to dark and the theme toggle is hidden (see Header SHOW_THEME_TOGGLE).
   While locked we ignore any persisted 'arc-theme', so a member previously on light
   resolves to dark (the effect below also rewrites their stored value to 'dark').
   Flip LOCK_DARK back to false to restore saved-choice behaviour when Phase 1 lands. */
const LOCK_DARK = true;

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    if (LOCK_DARK) return 'dark';
    try {
      return localStorage.getItem('arc-theme') || 'dark';
    } catch (e) {
      return 'dark';
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem('arc-theme', theme);
    } catch (e) {
      /* storage unavailable (private mode) — theme still applies for the session */
    }
  }, [theme]);

  return {
    theme,
    toggle: () => setTheme((t) => (t === 'dark' ? 'light' : 'dark')),
    setTheme,
  };
}

export default useTheme;
